// @oasis-permission-public: Basecamp reviews are available to every authenticated Oasis employee; the dashboard session and backend employee authorization remain required.
import { createFileRoute } from "@tanstack/react-router";

import { ensureSession } from "~/modules/auth/credentials";
import { BasecampStyleReviewsPage } from "~/modules/basecamp-style-reviews/basecamp-style-reviews-page";
import { reviewSearchSchema } from "~/modules/basecamp-style-reviews/schemas";

export const Route = createFileRoute("/_dash/basecamp-style-reviews")({
  validateSearch: reviewSearchSchema,
  beforeLoad() {
    ensureSession();
  },
  component: BasecampStyleReviewsPage,
});
